import { AddToGroupDialog } from '@/components/agent/AddToGroupDialog';
import { AddLabelDialog } from '@/components/agent/AddLabelDialog';
import type { Agent } from '@/lib/types';

interface TaxonomyActionDialogProps {
  agent: Agent;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/**
 * Adapters that fit the multi-select taxonomy pickers to the
 * `AgentActionDialogComponent` contract, so the group picker and "Add label"
 * can ride the shared agent action list (detail panel, rail pins, and the
 * command palette's "On this page" group) acting on the one open run.
 *
 * Imported eagerly rather than via `lazyDialogs`: the sidebar rows already
 * pull the underlying pickers into the main bundle, so lazy wrapping here
 * would split nothing.
 */
export function AddToGroupActionDialog({ agent, open, onOpenChange }: TaxonomyActionDialogProps) {
  return <AddToGroupDialog open={open} onOpenChange={onOpenChange} agents={[agent]} />;
}

export function AddLabelActionDialog({ agent, open, onOpenChange }: TaxonomyActionDialogProps) {
  return <AddLabelDialog open={open} onOpenChange={onOpenChange} agentIds={[agent.id]} />;
}
